export const BRAND = {
  name: "Invitation Wala",
  mark: "IW",
  tagline: "Premium Digital Invitations",
  instagram: "INVITATION_WALA_",
  instagramUrl: "https://www.instagram.com/invitation_wala_/",
  whatsapp: "917380587328",
  whatsappDisplay: "+91 73805 87328",
  hrWhatsapp: "919936120357",
  hrWhatsappDisplay: "+91 99361 20357",
  email: "invitationwala602@gmail.com",
  address: "A-1514, Spectrum Mall, Noida",
  logo: "/logos/invitation-wala.png",
  sister: {
    name: "Stationery Wala",
    tagline: "Premium printed wedding stationery",
    instagram: "stationery_wala__",
    instagramUrl: "https://www.instagram.com/stationery_wala__/",
    logo: "/logos/stationery-wala.png",
  },
};

export const PORTFOLIO_ITEMS = [
  {
    id: "p1",
    title: "The Kuldeep Chapter",
    category: "Celebrity Wedding · Film Invite",
    img: "https://customer-assets.emergentagent.com/job_portfolio-landing-49/artifacts/wssipa5q_WhatsApp%20Image%202026-04-18%20at%2013.07.06.jpeg",
  },
  {
    id: "p_eng",
    title: "Engagement & Cocktail",
    category: "Illuminated Invite · Starlit Gala",
    img: "https://customer-assets.emergentagent.com/job_portfolio-landing-49/artifacts/snzi2s2m_WhatsApp%20Image%202026-04-22%20at%2015.36.31.jpeg",
  },
  {
    id: "p_temple",
    title: "Temple Mandap Vision",
    category: "South Indian · Gallery Render",
    img: "https://customer-assets.emergentagent.com/job_portfolio-landing-49/artifacts/buyzfj3n_WhatsApp%20Image%202026-04-24%20at%2022.07.12.jpeg",
  },
  {
    id: "p2",
    title: "Wedding Day Newspaper",
    category: "Editorial · Keepsake",
    img: "https://customer-assets.emergentagent.com/job_portfolio-landing-49/artifacts/w40hkg7j_WhatsApp%20Image%202026-03-04%20at%2020.03.19%20-%20Copy.jpeg",
  },
  {
    id: "p5",
    title: "Hand-painted Welcome Sign",
    category: "Destination · Stationery",
    img: "https://customer-assets.emergentagent.com/job_portfolio-landing-49/artifacts/5zfsxqqn_WhatsApp%20Image%202026-02-14%20at%2023.56.46%20-%20Copy.jpeg",
  },
  {
    id: "p6",
    title: "Elephant Luggage Tags",
    category: "NRI Wedding · Guest Favour",
    img: "https://customer-assets.emergentagent.com/job_portfolio-landing-49/artifacts/h5dd1tf7_WhatsApp%20Image%202026-04-18%20at%2014.09.09.jpeg",
  },
];

export const SERVICES = [
  {
    id: "s1",
    title: "Wedding Invitations",
    desc: "Premium digital wedding invitations — refined typography, bespoke motion and a design language that carries your story from first look to final toast.",
    number: "01",
  },
  {
    id: "s2",
    title: "Stationery",
    desc: "A complete suite of designed stationery — RSVP cards, itineraries, menus and thank-you notes — woven into one cohesive aesthetic.",
    number: "02",
  },
  {
    id: "s3",
    title: "Story Invitations",
    desc: "Narrative, cinematic invites crafted around your real love story — unfolding chapter by chapter with custom art, voice and music.",
    number: "03",
  },
  {
    id: "s4",
    title: "Save-the-Dates",
    desc: "Poised, Instagram-ready save-the-date reels — subtle motion, elegant typography and tracks that linger long after the scroll.",
    number: "04",
  },
  {
    id: "s5",
    title: "Wardrobe",
    desc: "Curated wedding wardrobe planning for the couple and family — mood-boards, designer references and a look-book across every function.",
    number: "05",
  },
];

export const PROCESS = [
  {
    step: "I",
    title: "Schedule a Google Meet",
    desc: "We hop on a short video call to understand your story, event, design theme and overall vision.",
  },
  {
    step: "II",
    title: "WhatsApp Group",
    desc: "We create a private WhatsApp group with you and the family — one place for references, text, photos and instant updates.",
  },
  {
    step: "III",
    title: "Mood Boards",
    desc: "We share curated mood boards with colour palettes, typography and visual direction for your sign-off before design begins.",
  },
  {
    step: "IV",
    title: "Slide-by-Slide Previews",
    desc: "You see the invite come alive slide by slide — review, refine and approve each frame until every detail is perfect.",
  },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    quote:
      "The caricature invite was such a hit — every cousin and aunt forwarded it to us asking who made it!",
    author: "Aanya & Vihaan",
    event: "Wedding Invite, Delhi",
  },
  {
    id: "t2",
    quote:
      "Turned around our save-the-date in a single day. Bollywood music sync was perfect — 40k views on our reel.",
    author: "Riya Malhotra",
    event: "Save-the-Date Reel",
  },
  {
    id: "t3",
    quote:
      "Got the full Haldi–Mehendi–Sangeet–Wedding package. Consistent, beautiful, and way cheaper than printed cards.",
    author: "Dev & Ishaan",
    event: "Multi-Event Package, Jaipur",
  },
];

export const EVENT_TYPES = [
  "Wedding",
  "Save-the-Date",
  "Story Invitation",
  "Stationery",
  "Wardrobe",
  "Engagement / Roka",
  "Haldi · Mehendi · Sangeet",
  "Birthday",
  "Anniversary",
  "Corporate / Other",
];

export const JOB_ROLES = [
  {
    id: "j1",
    title: "Motion Designer",
    type: "Full-time · Noida",
    summary:
      "Breathe life into every frame. Craft cinematic invite films, save-the-date reels, and animated stationery using After Effects, Lottie, and a poet's eye for typography.",
    must: ["After Effects", "Typography sense", "Cinematic timing"],
  },
  {
    id: "j2",
    title: "Graphic Designer",
    type: "Full-time · Noida",
    summary:
      "Shape the mood. Design invite suites, social reels, printed stationery and brand collateral — from sketch to foiled paper, every detail lovingly placed.",
    must: ["Illustrator / Figma", "Indian typography", "Print & screen"],
  },
  {
    id: "j3",
    title: "Social Media Manager",
    type: "Full-time · Noida / Remote",
    summary:
      "Tell the atelier's story online. Plan reels, shoot BTS, grow our voice on Instagram with a discerning, luxe-first hand.",
    must: ["Instagram native", "Storyteller", "Creator-network aware"],
  },
  {
    id: "j4",
    title: "Client Relationship Lead",
    type: "Full-time · Noida",
    summary:
      "Be the first warm voice our couples hear on WhatsApp. Hold hands through the process, anticipate needs, and keep every family delighted end to end.",
    must: ["English + Hindi fluent", "Warm, proactive", "CRM discipline"],
  },
  {
    id: "j5",
    title: "Internship · Design & Motion",
    type: "3 — 6 months · Hybrid",
    summary:
      "Sit next to the founder. Learn the craft end to end — from pitch to delivered reel — on real weddings, real couples, real stakes.",
    must: ["Portfolio or student work", "Hungry to learn", "No attitude"],
  },
];

export const EXPERIENCE_LEVELS = [
  "Fresher / Student",
  "0 – 1 year",
  "1 – 3 years",
  "3 – 5 years",
  "5+ years",
];
